<div class="booking-container" *ngIf="!loader">
  <div class="heading_sert">
     <sm-title-bar pageTitle="Tax configurer" [backWithParams]="true" [headerCustomTemplate]="addButton">
      <ng-template #addButton>
         <div class="tax_btn d-flex search-field" >
           <button mat-icon-button color="accent" (click)="onClickAddNew()">
             <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
           </button>
         </div>
       </ng-template>
     </sm-title-bar>
  </div>
  <div class="chip_services_list" *ngIf="isEntityForeign == '0'">
   <mat-chip-listbox class="example-chip">
     <mat-chip   (click)="onSelectChip(i)" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" *ngFor="let item of taxData; let i = index">{{item.tax_name}}</mat-chip>

  </mat-chip-listbox>
 </div>
  <div class="chip_services_list" *ngIf="isEntityForeign == '1'">
   <mat-chip-listbox class="example-chip">
     <mat-chip  (click)="onclickInternationalChip(i)" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" *ngFor="let item of taxData;let i = index">{{item.slab_name}}</mat-chip>

  </mat-chip-listbox>
 </div>
  <div class="row">
     <!-- International tax start -->
     <div class="col-md-12" *ngIf="isEntityForeign == '1' && taxData.length > 0">
        <mat-card appearance="outlined" class="booking-form">
         <div class="serv_heading">
            <div class="adm_set">
               <div>
                 <button
                   mat-icon-button
                   [matMenuTriggerFor]="menu"
                   class="profile_button"
                   class="share">
                   <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                 </button>
                 <mat-menu #menu="matMenu">
                   <button mat-menu-item (click)="deleteInternationalTaxSlab()">
                     <mat-icon class="material-icons-outlined">delete</mat-icon>
                     <span class="menu_text">Delete</span>
                   </button>
                 </mat-menu>
               </div>

             </div>
            <h3>{{selectedSlab.slab_name}} configuration </h3>
        </div>
        <div class="inter_set">
          <!-- <div class="">
              <h3>Configure tax id type</h3>
          </div>  
          <form [formGroup]="taxTypeform">
            <div formArrayName="types">
               <div class="row" *ngFor="let item of types.controls; let i = index" [formGroupName]="i"> 
             <div class="col-sm-5" >
             <mat-form-field appearance="outline">
               <mat-label>Tax id</mat-label>
               <input matInput #input formControlName="tax_type">
             </mat-form-field>
             </div>
             
             <div class="col-sm-6">
               <mat-form-field appearance="outline">
                 <mat-label>Tax id no</mat-label>
                 <input matInput #input formControlName="identification_no">   
               </mat-form-field>
            </div>
            <div class="col-sm-1">
               
               <span>
                  <mat-icon style="    position: relative;
                  top: 15px;
                  color: #D70D0D; cursor: pointer;
              " (click)="removeFormFieldForTypes(i)">delete</mat-icon>
               </span>
             </div>
             
             </div>
             <div class="add_newrt">
               <button mat-flat-button color="primary" (click)="addTaxTypeField()"> <mat-icon>add</mat-icon> Add tax type</button>
             </div>

            </div>

          </form> -->
        
          <div>
            <mat-form-field appearance="outline">
               <mat-label>Configuration name</mat-label>
               <input matInput #input [(ngModel)]="intTaxObj.slab_name">
              
            </mat-form-field>
         </div>
         <div>
            <mat-form-field appearance="outline">
               <mat-label>Configuration description</mat-label>
               <textarea matInput #input [(ngModel)]="intTaxObj.slab_desc"></textarea>
              
            </mat-form-field>
         </div>  
        <form [formGroup]="taxValueform">
         <div formArrayName="values">
            <div class="row" *ngFor="let item of values.controls; let i = index" [formGroupName]="i">
            <div class="col-5" >
            <mat-form-field appearance="outline">
            <mat-label>Tax name</mat-label>
            <input matInput #input formControlName="tax_name">
            </mat-form-field>
            </div>
            
            <div class="col-5">
            <mat-form-field appearance="outline">
            <mat-label>Tax percentage</mat-label>
            <input matInput #input formControlName="tax_value"  smDecimalOnly  type="number">   
            </mat-form-field>
            </div>
            <div class="col-2">
               <span>
                  <mat-icon style="    position: relative;
                  top: 15px;
                  color: #D70D0D; cursor: pointer;
              " (click)="removeFormFieldForValues(i)">delete</mat-icon>
               </span>
             </div>
            </div>
            
            
            <div class="add_newrt">
            <button mat-flat-button color="primary" (click)="addTaxValueField()"> <mat-icon>add</mat-icon> Add tax value</button>
            </div>
         </div>
        </form> 
        
        </div>
        <div class="cabh_sect">
          <!-- <button  mat-flat-button color="accent" class="resat-btn" >Reset</button> -->
        <button mat-flat-button color="accent" class="submit-btn" [disabled]="taxValueform.invalid" (click)="onSaveInternationalTax()">Save</button>
        </div>
        </mat-card>
        </div>
     <!-- International tax end -->


     <!-- Domestic tax start -->
     <div class="col-sm-12" *ngIf="isEntityForeign == '0' && taxData.length > 0">
        <div class="lsk_cardf">
         <div class="serv_heading">
            <div class="adm_set">
               <div>
                 <button
                   mat-icon-button
                   [matMenuTriggerFor]="menu"
                   class="profile_button"
                   class="share">
                   <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                 </button>
                 <mat-menu #menu="matMenu">
                   <button mat-menu-item (click)="deleteDomesticTaxSlab()">
                     <mat-icon class="material-icons-outlined">delete</mat-icon>
                     <span class="menu_text">Delete</span>
                   </button>
                 </mat-menu>
               </div>

             </div>
            <h3>{{selectedSlab.tax_name}} configuration </h3>
        </div>
           <div>
              <mat-form-field appearance="outline">
                 <mat-label>Configuration name</mat-label>
                 <input matInput #input [(ngModel)]="taxObj.tax_name">
                
              </mat-form-field>
           </div>
           <div>
              <mat-form-field appearance="outline">
                 <mat-label>Configuration description</mat-label>
                 <textarea matInput #input [(ngModel)]="taxObj.tax_desc"></textarea>
                
              </mat-form-field>
           </div>
           <div class="item_list add_padding">
              <div class="item_list_data add_margin_bottom">
                 <span>GST Status</span>
                 <mat-slide-toggle (change)="onToggleChange($event)" [checked]="taxObj.gstStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <!-- <div *ngIf="taxObj.gstStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>GST Number</mat-label>
                 <input matInput #input [(ngModel)]="taxObj.gstNumber">
                
              </mat-form-field>
           </div> -->
           <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
            <div class="item_list_data add_margin_bottom">
               <span>SGST</span>
               <mat-slide-toggle (change)="onToggleChangeSGST($event)" [checked]="taxObj.sgstStatus == 1"></mat-slide-toggle>
            </div>
         </div>
         <div *ngIf="taxObj.sgstStatus === 1 && taxObj.gstStatus === 1">
            <mat-form-field appearance="outline">
               <mat-label>SGST Rate</mat-label>
               <input matInput #input  smDecimalOnly  type="number" [(ngModel)]="taxObj.sgstValue">
              
            </mat-form-field>
         </div>
           <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
              <div class="item_list_data add_margin_bottom">
                 <span>CGST</span>
                 <mat-slide-toggle (change)="onToggleChangeCGST($event)" [checked]="taxObj.cgstStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <div *ngIf="taxObj.cgstStatus === 1 && taxObj.gstStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>CGST Rate</mat-label>
                 <input matInput #input [(ngModel)]="taxObj.cgstValue"  smDecimalOnly  type="number">
                
              </mat-form-field>
           </div>
           <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
              <div class="item_list_data add_margin_bottom">
                 <span>IGST</span>
                 <mat-slide-toggle (change)="onToggleChangeIGST($event)" [checked]="taxObj.igstStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <div *ngIf="taxObj.igstStatus === 1 && taxObj.gstStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>IGST Rate</mat-label>
                 <input matInput #input   smDecimalOnly  type="number" [(ngModel)]="taxObj.igstValue">
                
              </mat-form-field>
           </div>
           
           <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
              <div class="item_list_data add_margin_bottom">
                 <span>UTGST</span>
                 <mat-slide-toggle (change)="onToggleChangeUTGST($event)" [checked]="taxObj.utgstStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <div *ngIf="taxObj.utgstStatus === 1 && taxObj.gstStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>UTGST Rate</mat-label>
                 <input matInput #input  smDecimalOnly  type="number" [(ngModel)]="taxObj.utgstValue">
                
              </mat-form-field>
           </div>
           <div class="item_list add_padding" >
              <div class="item_list_data add_margin_bottom">
                 <span>Service Tax</span>
                 <mat-slide-toggle (change)="onToggleChangeServiceTax($event)" [checked]="taxObj.serviceTaxStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <div *ngIf="taxObj.serviceTaxStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>Service Tax Rate</mat-label>
                 <input matInput #input  smDecimalOnly  type="number" [(ngModel)]="taxObj.serviceTaxValue">
                
              </mat-form-field>
           </div>
           <div class="item_list add_padding" >
              <div class="item_list_data add_margin_bottom">
                 <span>Other Tax</span>
                 <mat-slide-toggle (change)="onToggleChangeOtherTax($event)" [checked]="taxObj.otherTaxStatus == 1"></mat-slide-toggle>
              </div>
           </div>
           <div  *ngIf="taxObj.otherTaxStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>Other Tax Name</mat-label>
                 <input matInput #input [(ngModel)]="taxObj.otherTaxName">
                
              </mat-form-field>
           </div>
           <div *ngIf="taxObj.otherTaxStatus === 1">
              <mat-form-field appearance="outline">
                 <mat-label>Other Tax Rate</mat-label>
                 <input matInput #input smDecimalOnly  type="number"  [(ngModel)]="taxObj.otherTax">
                
              </mat-form-field>
           </div>
           <div class="cabh_sect">
            <!-- <button  mat-flat-button color="accent" class="resat-btn" (click)="onReset()">Reset</button> -->
          <button mat-flat-button color="accent" class="submit-btn" [disabled]="
          !taxObj.tax_name
          " (click)="onSubmitTaxDetails()">Save</button>
          </div>
        </div>
     </div>
     <!-- Domestic tax end -->

     <!-- placeholder starts -->
     <div class="col-sm-12" *ngIf="taxData.length == 0">
      <div class="placeholder_textfg">
         <div class="data_addedf_icon">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M267 438H64.99c-5.522 0-10 4.477-10 10s4.478 10 10 10H267c5.522 0 10-4.477 10-10s-4.478-10-10-10zM72.059 384.93A10.072 10.072 0 0 0 64.99 382c-2.631 0-5.211 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07a10.072 10.072 0 0 0 7.07 2.93c2.63 0 5.21-1.07 7.069-2.93 1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07zM267 382H109c-5.522 0-10 4.477-10 10s4.478 10 10 10h158c5.522 0 10-4.477 10-10s-4.478-10-10-10zM267 326H64c-5.522 0-10 4.477-10 10s4.478 10 10 10h203c5.522 0 10-4.477 10-10s-4.478-10-10-10zM72.059 272.93A10.072 10.072 0 0 0 64.99 270c-2.631 0-5.211 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07a10.072 10.072 0 0 0 7.07 2.93c2.63 0 5.21-1.07 7.069-2.93A10.059 10.059 0 0 0 74.99 280c0-2.63-1.07-5.21-2.931-7.07zM267 270H109c-5.522 0-10 4.477-10 10s4.478 10 10 10h158c5.522 0 10-4.477 10-10s-4.478-10-10-10zM117.453 119.812H64c-5.522 0-10 4.477-10 10s4.478 10 10 10h16.727v74.795c0 5.523 4.478 10 10 10s10-4.477 10-10v-74.795h16.727c5.522 0 10-4.477 10-10s-4.478-10-10.001-10zM217.783 210.704l-35.743-84.158a10 10 0 0 0-18.408 0l-35.744 84.158c-2.159 5.084.212 10.955 5.295 13.113a9.961 9.961 0 0 0 3.904.798c3.892 0 7.592-2.286 9.209-6.093l6.393-15.05h40.294l6.392 15.05c2.159 5.084 8.029 7.455 13.113 5.295 5.083-2.159 7.454-8.03 5.295-13.113zm-56.6-27.231 11.653-27.437 11.653 27.437h-23.306zM276.195 172.228l23.511-37.072c2.957-4.663 1.574-10.842-3.09-13.8-4.665-2.959-10.844-1.574-13.801 3.089l-18.462 29.111-18.462-29.111c-2.958-4.663-9.135-6.047-13.801-3.089-4.664 2.958-6.047 9.137-3.09 13.801l23.511 37.072L229 209.3c-2.957 4.664-1.574 10.843 3.09 13.801a9.993 9.993 0 0 0 13.801-3.089l18.462-29.111 18.462 29.111a9.994 9.994 0 0 0 13.801 3.089c4.664-2.958 6.047-9.137 3.09-13.801l-23.511-37.072z" fill="#a8a8a8" opacity="1" data-original="#000000" class=""></path><path d="M485 227.938H327c-14.888 0-27 12.112-27 27V485c0 2.421.325 4.766.926 7H30c-5.514 0-10-4.486-10-10V30c0-5.514 4.486-10 10-10h283v60.867c0 16.685 13.574 30.26 30.26 30.26H404v82.345c0 5.523 4.478 10 10 10s10-4.477 10-10v-92.345l-.024.002c0-2.602-.993-5.16-2.905-7.073l-91-91c-1.922-1.922-4.496-2.913-7.112-2.903.016-.054.025-.099.041-.153H30C13.458 0 0 13.458 0 30v452c0 16.542 13.458 30 30 30h455c14.888 0 27-12.112 27-27V254.938c0-14.888-12.112-27-27-27zM333 34.269l56.857 56.858H343.26c-5.657 0-10.26-4.603-10.26-10.26V34.269zM492 485c0 3.86-3.141 7-7 7H327c-3.859 0-7-3.14-7-7V254.938c0-3.86 3.141-7 7-7h158c3.859 0 7 3.14 7 7V485z" fill="#a8a8a8" opacity="1" data-original="#000000" class=""></path><path d="M462 267.938H350c-5.522 0-10 4.477-10 10v40c0 5.523 4.478 10 10 10h112c5.522 0 10-4.477 10-10v-40c0-5.523-4.478-10-10-10zm-10 40h-92v-20h92v20zM362 355.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM412 355.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM462 355.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM362 403.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM412 403.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM462 403.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM362 451.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM412 451.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10zM462 451.938h-12c-5.522 0-10 4.477-10 10s4.478 10 10 10h12c5.522 0 10-4.477 10-10s-4.478-10-10-10z" fill="#a8a8a8" opacity="1" data-original="#000000" class=""></path></g></svg>
         </div>
         <!-- <p>No data added</p> -->
          <p>Manage and configure tax settings tailored to your business needs. Define tax rates, and custom rules  for your products and services. </p>
      </div>
      </div>
     <!-- placeholder ends -->




     
  </div>
</div>